export const selectSaisines = (store) => store.saisine.list;
export const selectSaisinesTotal = (store) => store.saisine.total;
export const selectSaisine = (store) => store.saisine.saisine;
export const selectSaisineRejected = (store) => store.saisine.rejected;
export const selectEligibleClaims = (store) => store.saisine.eligibleClaims;
export const selectAutofill = (store) => store.saisine.autofill;
export const selectAutofillReport = (store) => store.saisine.autofillReport;
export const selectSaisineErrors = (store) => store.saisine.errorsInfo;
export const selectSaisineListLoading = (store) => store.saisine.loadingState.list;
export const selectSaisineLoading = (store) => store.saisine.loadingState.saisine;
export const selectSaisineActionLoading = (store) => store.saisine.loadingState.action;
export const selectEligibleLoading = (store) => store.saisine.loadingState.eligible;
export const selectAutofillLoading = (store) => store.saisine.loadingState.autofill;
